import React, { ReactNode, useEffect, useState } from "react";
import { Grid } from "react-bootstrap";
import { useGlobalContext } from "../../../context/global/state";
import DynamicDate from "components/controllers/shared/dynamicDate/dynamicDate";
import NoDemoLink from "components/controllers/shared/tooltip/noDemoLink";
import sass from "components/controllers/shared/styled/sass";

const Footer: React.FC<{ children?: ReactNode }> = ({ children }) => {
	const [menuRef, setMenuRef] = useState<any>(null);
	const { state, dispatch } = useGlobalContext();

	const ref = React.createRef<HTMLDivElement>();
	// Save ref to global state
	useEffect(() => {
		if (ref.current) {
			if (!state.primaryFooter) {
				setMenuRef(ref.current);
				dispatch({ type: "primaryFooter", payload: ref.current });
			}
		}
	}, [ref, state.primaryFooter, menuRef, dispatch]);

	const footerProps = {
		ref,
		className: `footer`,
	};

	const { charcoal, gray } = sass.variables.color;

	const span = {
		style: {
			color: charcoal,
			borderLeft: `2px solid ${gray}`,
		},
		className: "util-padding-horz-15",
	};

	return (
		<footer {...footerProps}>
			<section className="footer-row">
				{children}
				<Grid className="util-padding-vert-15 demo-disclaimer small">
					Images and numerical information in this demo are for
					illustrative purposes only.
				</Grid>
				<nav>
					<ul className="nav nav-inline">
						<li>
							<NoDemoLink>
								<span
									className="util-padding-horz-15"
									style={{ color: charcoal }}
								>
									Terms of Use
								</span>
							</NoDemoLink>
						</li>
						<li>
							<NoDemoLink>
								<span {...span}>Disclosures</span>
							</NoDemoLink>
						</li>
						<li>
							<NoDemoLink>
								<span {...span}>Privacy</span>
							</NoDemoLink>
						</li>
						<li>
							<NoDemoLink>
								<span {...span}>Security</span>
							</NoDemoLink>
						</li>
						<li>
							<NoDemoLink>
								<span {...span}>Report Fraud</span>
							</NoDemoLink>
						</li>
						<li>
							<NoDemoLink>
								<span {...span}>Site Map</span>
							</NoDemoLink>
						</li>
						<li>
							<NoDemoLink>
								<span {...span}>Contact Us</span>
							</NoDemoLink>
						</li>
					</ul>
				</nav>
				<div className="footer-legal">
					<p>
						&copy; <DynamicDate dateType={"currentYear"} />,
						Principal Financial Services, Inc.
					</p>
					<p>
						Securities offered through Principal Securities, Inc.,
						member SIPC
					</p>
				</div>
			</section>
		</footer>
	);
};

export default Footer;
